package com.loyola.acessoescola.ui.theme
import androidx.compose.ui.graphics.Color

val primaryLight = Color(0xFF4D5C92)
val onPrimaryLight = Color(0xFFFFFFFF)
val primaryContainerLight = Color(0xFFDCE1FF)
val onPrimaryContainerLight = Color(0xFF354479)
val secondaryLight = Color(0xFF8D4959)
val onSecondaryLight = Color(0xFFFFFFFF)
val secondaryContainerLight = Color(0xFFFFD9DF)
val onSecondaryContainerLight = Color(0xFF713342)
val tertiaryLight = Color(0xFF79590C)
val onTertiaryLight = Color(0xFFFFFFFF)
val tertiaryContainerLight = Color(0xFFFFDEA2)
val onTertiaryContainerLight = Color(0xFF5C4200)
val errorLight = Color(0xFFBA1A1A)
val onErrorLight = Color(0xFFFFFFFF)
val errorContainerLight = Color(0xFFFFDAD6)
val onErrorContainerLight = Color(0xFF93000A)
val backgroundLight = Color(0xFFFAF8FF)
val onBackgroundLight = Color(0xFF1A1B21)
val surfaceLight = Color(0xFFFAF8FF)
val onSurfaceLight = Color(0xFF1A1B21)
val surfaceVariantLight = Color(0xFFF3DDE0)
val onSurfaceVariantLight = Color(0xFF524345)
val outlineLight = Color(0xFF847375)
val outlineVariantLight = Color(0xFFD6C2C4)
val scrimLight = Color(0xFF000000)
val inverseSurfaceLight = Color(0xFF2F3036)
val inverseOnSurfaceLight = Color(0xFFF1F0F7)
val inversePrimaryLight = Color(0xFFB6C4FF)
val surfaceDimLight = Color(0xFFDAD9E0)
val surfaceBrightLight = Color(0xFFFAF8FF)
val surfaceContainerLowestLight = Color(0xFFFFFFFF)
val surfaceContainerLowLight = Color(0xFFF4F3FA)
val surfaceContainerLight = Color(0xFFEFEDF4)
val surfaceContainerHighLight = Color(0xFFE9E7EF)
val surfaceContainerHighestLight = Color(0xFFE3E1E9)

val primaryLightMediumContrast = Color(0xFF243367)
val onPrimaryLightMediumContrast = Color(0xFFFFFFFF)
val primaryContainerLightMediumContrast = Color(0xFF5C6AA2)
val onPrimaryContainerLightMediumContrast = Color(0xFFFFFFFF)
val secondaryLightMediumContrast = Color(0xFF5D2232)
val onSecondaryLightMediumContrast = Color(0xFFFFFFFF)
val secondaryContainerLightMediumContrast = Color(0xFF9F5867)
val onSecondaryContainerLightMediumContrast = Color(0xFFFFFFFF)
val tertiaryLightMediumContrast = Color(0xFF483300)
val onTertiaryLightMediumContrast = Color(0xFFFFFFFF)
val tertiaryContainerLightMediumContrast = Color(0xFF89681C)
val onTertiaryContainerLightMediumContrast = Color(0xFFFFFFFF)
val errorLightMediumContrast = Color(0xFF740006)
val onErrorLightMediumContrast = Color(0xFFFFFFFF)
val errorContainerLightMediumContrast = Color(0xFFCF2C27)
val onErrorContainerLightMediumContrast = Color(0xFFFFFFFF)
val backgroundLightMediumContrast = Color(0xFFFAF8FF)
val onBackgroundLightMediumContrast = Color(0xFF1A1B21)
val surfaceLightMediumContrast = Color(0xFFFAF8FF)
val onSurfaceLightMediumContrast = Color(0xFF101116)
val surfaceVariantLightMediumContrast = Color(0xFFF3DDE0)
val onSurfaceVariantLightMediumContrast = Color(0xFF403335)
val outlineLightMediumContrast = Color(0xFF5E4F51)
val outlineVariantLightMediumContrast = Color(0xFF7A696B)
val scrimLightMediumContrast = Color(0xFF000000)
val inverseSurfaceLightMediumContrast = Color(0xFF2F3036)
val inverseOnSurfaceLightMediumContrast = Color(0xFFF1F0F7)
val inversePrimaryLightMediumContrast = Color(0xFFB6C4FF)
val surfaceDimLightMediumContrast = Color(0xFFC7C6CD)
val surfaceBrightLightMediumContrast = Color(0xFFFAF8FF)
val surfaceContainerLowestLightMediumContrast = Color(0xFFFFFFFF)
val surfaceContainerLowLightMediumContrast = Color(0xFFF4F3FA)
val surfaceContainerLightMediumContrast = Color(0xFFE9E7EF)
val surfaceContainerHighLightMediumContrast = Color(0xFFDDDCE3)
val surfaceContainerHighestLightMediumContrast = Color(0xFFD2D1D8)

val primaryLightHighContrast = Color(0xFF19285C)
val onPrimaryLightHighContrast = Color(0xFFFFFFFF)
val primaryContainerLightHighContrast = Color(0xFF38467B)
val onPrimaryContainerLightHighContrast = Color(0xFFFFFFFF)
val secondaryLightHighContrast = Color(0xFF501828)
val onSecondaryLightHighContrast = Color(0xFFFFFFFF)
val secondaryContainerLightHighContrast = Color(0xFF743544)
val onSecondaryContainerLightHighContrast = Color(0xFFFFFFFF)
val tertiaryLightHighContrast = Color(0xFF3B2900)
val onTertiaryLightHighContrast = Color(0xFFFFFFFF)
val tertiaryContainerLightHighContrast = Color(0xFF5F4500)
val onTertiaryContainerLightHighContrast = Color(0xFFFFFFFF)
val errorLightHighContrast = Color(0xFF600004)
val onErrorLightHighContrast = Color(0xFFFFFFFF)
val errorContainerLightHighContrast = Color(0xFF98000A)
val onErrorContainerLightHighContrast = Color(0xFFFFFFFF)
val backgroundLightHighContrast = Color(0xFFFAF8FF)
val onBackgroundLightHighContrast = Color(0xFF1A1B21)
val surfaceLightHighContrast = Color(0xFFFAF8FF)
val onSurfaceLightHighContrast = Color(0xFF000000)
val surfaceVariantLightHighContrast = Color(0xFFF3DDE0)
val onSurfaceVariantLightHighContrast = Color(0xFF000000)
val outlineLightHighContrast = Color(0xFF36292B)
val outlineVariantLightHighContrast = Color(0xFF544548)
val scrimLightHighContrast = Color(0xFF000000)
val inverseSurfaceLightHighContrast = Color(0xFF2F3036)
val inverseOnSurfaceLightHighContrast = Color(0xFFFFFFFF)
val inversePrimaryLightHighContrast = Color(0xFFB6C4FF)
val surfaceDimLightHighContrast = Color(0xFFB9B8BF)
val surfaceBrightLightHighContrast = Color(0xFFFAF8FF)
val surfaceContainerLowestLightHighContrast = Color(0xFFFFFFFF)
val surfaceContainerLowLightHighContrast = Color(0xFFF1F0F7)
val surfaceContainerLightHighContrast = Color(0xFFE3E1E9)
val surfaceContainerHighLightHighContrast = Color(0xFFD5D3DB)
val surfaceContainerHighestLightHighContrast = Color(0xFFC7C6CD)

val primaryDark = Color(0xFF626EC6)
val onPrimaryDark = Color(0xFFDCE1FF)
val primaryContainerDark = Color(0xFF354479)
val onPrimaryContainerDark = Color(0xFFDCE1FF)
val secondaryDark = Color(0xE8D76A7B)
val onSecondaryDark = Color(0xFF551D2C)
val secondaryContainerDark = Color(0xFF713342)
val onSecondaryContainerDark = Color(0xFFFFD9DF)
val tertiaryDark = Color(0xFFEBC16C)
val onTertiaryDark = Color(0xFF402D00)
val tertiaryContainerDark = Color(0xFF5C4200)
val onTertiaryContainerDark = Color(0xFFFFDEA2)
val errorDark = Color(0xFFFFB4AB)
val onErrorDark = Color(0xFF690005)
val errorContainerDark = Color(0xFF93000A)
val onErrorContainerDark = Color(0xFFFFDAD6)
val backgroundDark = Color(0xFF121318)
val onBackgroundDark = Color(0xFFE3E1E9)
val surfaceDark = Color(0xFF121318)
val onSurfaceDark = Color(0xFFE3E1E9)
val surfaceVariantDark = Color(0xFF524345)
val onSurfaceVariantDark = Color(0xFFD6C2C4)
val outlineDark = Color(0xFF9F8C8F)
val outlineVariantDark = Color(0xFF524345)
val scrimDark = Color(0xFF000000)
val inverseSurfaceDark = Color(0xFFE3E1E9)
val inverseOnSurfaceDark = Color(0xFF2F3036)
val inversePrimaryDark = Color(0xFF4D5C92)
val surfaceDimDark = Color(0xFF121318)
val surfaceBrightDark = Color(0xFF38393F)
val surfaceContainerLowestDark = Color(0xFF0D0E13)
val surfaceContainerLowDark = Color(0xFF1A1B21)
val surfaceContainerDark = Color(0xFF1E1F25)
val surfaceContainerHighDark = Color(0xFF292A2F)
val surfaceContainerHighestDark = Color(0xFF34343A)

val primaryDarkMediumContrast = Color(0xFFD4DBFF)
val onPrimaryDarkMediumContrast = Color(0xFF112255)
val primaryContainerDarkMediumContrast = Color(0xFF808EC8)
val onPrimaryContainerDarkMediumContrast = Color(0xFF000000)
val secondaryDarkMediumContrast = Color(0xFFFFD1D8)
val onSecondaryDarkMediumContrast = Color(0xFF481221)
val secondaryContainerDarkMediumContrast = Color(0xFFC87A8B)
val onSecondaryContainerDarkMediumContrast = Color(0xFF000000)
val tertiaryDarkMediumContrast = Color(0xFFFFD78A)
val onTertiaryDarkMediumContrast = Color(0xFF332300)
val tertiaryContainerDarkMediumContrast = Color(0xFFB08B3D)
val onTertiaryContainerDarkMediumContrast = Color(0xFF000000)
val errorDarkMediumContrast = Color(0xFFFFD2CC)
val onErrorDarkMediumContrast = Color(0xFF540003)
val errorContainerDarkMediumContrast = Color(0xFFFF5449)
val onErrorContainerDarkMediumContrast = Color(0xFF000000)
val backgroundDarkMediumContrast = Color(0xFF121318)
val onBackgroundDarkMediumContrast = Color(0xFFE3E1E9)
val surfaceDarkMediumContrast = Color(0xFF121318)
val onSurfaceDarkMediumContrast = Color(0xFFFFFFFF)
val surfaceVariantDarkMediumContrast = Color(0xFF524345)
val onSurfaceVariantDarkMediumContrast = Color(0xFFEDD7DA)
val outlineDarkMediumContrast = Color(0xFFC1ADB0)
val outlineVariantDarkMediumContrast = Color(0xFF9E8C8E)
val scrimDarkMediumContrast = Color(0xFF000000)
val inverseSurfaceDarkMediumContrast = Color(0xFFE3E1E9)
val inverseOnSurfaceDarkMediumContrast = Color(0xFF292A2F)
val inversePrimaryDarkMediumContrast = Color(0xFF36457A)
val surfaceDimDarkMediumContrast = Color(0xFF121318)
val surfaceBrightDarkMediumContrast = Color(0xFF44444A)
val surfaceContainerLowestDarkMediumContrast = Color(0xFF06070C)
val surfaceContainerLowDarkMediumContrast = Color(0xFF1C1D23)
val surfaceContainerDarkMediumContrast = Color(0xFF27272D)
val surfaceContainerHighDarkMediumContrast = Color(0xFF323238)
val surfaceContainerHighestDarkMediumContrast = Color(0xFF3D3D43)

val primaryDarkHighContrast = Color(0xFFEEEFFF)
val onPrimaryDarkHighContrast = Color(0xFF000000)
val primaryContainerDarkHighContrast = Color(0xFFB2C0FD)
val onPrimaryContainerDarkHighContrast = Color(0xFF00082B)
val secondaryDarkHighContrast = Color(0xFFFFEBED)
val onSecondaryDarkHighContrast = Color(0xFF000000)
val secondaryContainerDarkHighContrast = Color(0xFFFFACBC)
val onSecondaryContainerDarkHighContrast = Color(0xFF210008)
val tertiaryDarkHighContrast = Color(0xFFFFEED3)
val onTertiaryDarkHighContrast = Color(0xFF000000)
val tertiaryContainerDarkHighContrast = Color(0xFFE7BD69)
val onTertiaryContainerDarkHighContrast = Color(0xFF120A00)
val errorDarkHighContrast = Color(0xFFFFECE9)
val onErrorDarkHighContrast = Color(0xFF000000)
val errorContainerDarkHighContrast = Color(0xFFFFAEA4)
val onErrorContainerDarkHighContrast = Color(0xFF220001)
val backgroundDarkHighContrast = Color(0xFF121318)
val onBackgroundDarkHighContrast = Color(0xFFE3E1E9)
val surfaceDarkHighContrast = Color(0xFF121318)
val onSurfaceDarkHighContrast = Color(0xFFFFFFFF)
val surfaceVariantDarkHighContrast = Color(0xFF524345)
val onSurfaceVariantDarkHighContrast = Color(0xFFFFFFFF)
val outlineDarkHighContrast = Color(0xFFFFEBED)
val outlineVariantDarkHighContrast = Color(0xFFD2BEC0)
val scrimDarkHighContrast = Color(0xFF000000)
val inverseSurfaceDarkHighContrast = Color(0xFFE3E1E9)
val inverseOnSurfaceDarkHighContrast = Color(0xFF000000)
val inversePrimaryDarkHighContrast = Color(0xFF36457A)
val surfaceDimDarkHighContrast = Color(0xFF121318)
val surfaceBrightDarkHighContrast = Color(0xFF4F5056)
val surfaceContainerLowestDarkHighContrast = Color(0xFF000000)
val surfaceContainerLowDarkHighContrast = Color(0xFF1E1F25)
val surfaceContainerDarkHighContrast = Color(0xFF2F3036)
val surfaceContainerHighDarkHighContrast = Color(0xFF3A3B41)
val surfaceContainerHighestDarkHighContrast = Color(0xFF46464C)








